import "./Queue.scss";
import QueueItem from "../QueueItem/QueueItem";

const Queue = ({ queueData, deleteHandler, editHandler, editErrors }) => {
  queueData.sort((a, b) => a.datetime - b.datetime);

  return (
    <section className="queue">
      <div className="queue__container">
        <h2 className="queue__title">Your Queue</h2>
        <p className="queue__text">{`${queueData.length} / 5`}</p>
      </div>
      <ul className="queue__list">
        {queueData.length === 0 && (
          <p className="queue__list-text">No posts scheduled</p>
        )}
        {queueData.map((item, i) => (
          <li className="queue__list-item" key={item.id}>
            <QueueItem
              item={item}
              priority={i + 1}
              deleteHandler={deleteHandler}
              editHandler={editHandler}
              editErrors={editErrors}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Queue;
